import React from 'react';
import { CardElement, PaymentElement, AddressElement } from '@stripe/react-stripe-js';
import { AddressMode } from '@stripe/stripe-js';

import { Col, Form } from 'antd';

import './paymentElement.scss';

export const PaymentElementSection = () => {
    const CARD_OPTIONS = {
        disableWallets: ['applePay', 'googlePay'],
        hidePostalCode: true,
        style: {
            base: {
                fontSize: '16px',
                color: '#424770',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };

    const ADDRESS_OPTIONS = {
        mode: 'billing' as AddressMode,
        fields: {
            phone: 'always' as 'always' | 'never' | 'auto',
            address: 'always' as 'always' | 'never' | 'auto',
        },
        appearance: {
            theme: 'flat', // best for full control
            variables: {
                // COLORS & TYPOGRAPHY
                colorPrimaryText: 'rgba(0, 0, 0, 0.85)', // base text
                colorTextPlaceholder: '#CFD7DF',
                colorBackground: '#fff',
                colorBorder: '#d9d9d9',
                colorErrorText: '#e5424d',
                colorSuccessText: '#4CAF50',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontLineHeight: '1.5715',
                fontSizeBase: '14px',
                fontWeightNormal: '400',

                // SPACING
                spacingUnit: '4px', // this will apply to margin/padding grid
                spacingGridRow: '4px',
                spacingGridColumn: '11px',

                // RADIUS & TRANSITION
                borderRadius: '2px',
                transitionDuration: '0.3s',
            },
            rules: {
                // Apply box-sizing, display, width, etc.
                '.Input, .Block': {
                    boxSizing: 'border-box',
                    display: 'inline-block',
                    width: '100%',
                    margin: '0',
                    position: 'relative',
                },
                // Add the transition on the actual input wrapper
                '.Input': {
                    transition: 'all {{transitionDuration}}',
                },
            },
        },
        // style: {
        //     base: {
        //         boxSizing: 'border-box',
        //         margin: '0',
        //         padding: '4px 11px',
        //         fontVariant: 'tabular-nums',
        //         listStyle: 'none',
        //         fontFeatureSettings: '"tnum"',
        //         position: 'relative',
        //         display: 'inline-block',
        //         width: '100%',
        //         minWidth: '0',
        //         color: 'rgba(0, 0, 0, 0.85)',
        //         fontSize: '14px',
        //         lineHeight: '1.5715',
        //         backgroundColor: '#fff',
        //         backgroundImage: 'none',
        //         border: '1px solid #d9d9d9',
        //         borderRadius: '2px',
        //         transition: 'all 0.3s',
        //         '::placeholder': {
        //             color: '#CFD7DF',
        //         },
        //     },
        //     invalid: {
        //         color: '#e5424d',
        //         '::placeholder': {
        //             color: '#FFCCA5',
        //         },
        //     },
        //     complete: {
        //         color: '#4CAF50',
        //     },
        // },
    };

    return (
        <>
            <Col span={24} className="mt-2">
                <Form.Item label="Card Information" name="card" required>
                    <CardElement options={CARD_OPTIONS} />
                    {/* <PaymentElement /> */}
                </Form.Item>
                <Form.Item name="address">
                    {/* <div className="stripe-address-element-wrapper"> */}
                    <AddressElement options={ADDRESS_OPTIONS} />
                    {/* </div> */}
                </Form.Item>
            </Col>
        </>
    );
};
